/**
 * FeatureTile.jsx
 * Team: TA37 - The Coders' Assembly
 */

import React from 'react';
import './FeatureTile.css';

const FeatureTile = ({ icon, imageUrl, title, description, className = '' }) => {
  return (
    <article className={`feature-tile ${className}`} aria-label={title}>

      {imageUrl && (
        <img
          className="feature-tile__image"
          src={imageUrl}
          alt=""
          loading="lazy"
        />
      )}

      {/* -- Icon container (decorative, hidden from screen readers) -- */}
      {icon && !imageUrl && (
        <div className="feature-tile__icon" aria-hidden="true">
          {icon}
        </div>
      )}

      {/* -- Tile heading -- */}
      <h3 className="feature-tile__title">{title}</h3>

      {/* -- Tile description -- */}
      <p className="feature-tile__description">{description}</p>

    </article>
  );
};

export default FeatureTile;
